import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import JsonEditor from '../../../../layout/components/JsonEditor';
import { get } from '../../../../utils/api';  // Assuming you have a utility function for API requests

export default function CollectionSettings(props: any) {
    const [jsonData, setJsonData] = useState<any[]>([]);  // Initializes jsonData as an empty array

    useEffect(() => {
        // Function to fetch JSON data from the side_menu_settings collection
        const fetchJsonData = async () => {
            try {
                const response = await get('field_settings',{});  // Adjust the API endpoint as necessary
                setJsonData(response.data.data);  // Assuming the response has the data in the 'data' key
            } catch (error) {
                console.error('Failed to fetch JSON data:', error);
            }
        };

        fetchJsonData();
    }, []);  // The empty dependency array ensures this effect runs only once after the component mounts

    const handleJsonChange = (updatedJson: any) => {
        console.log('Updated JSON:', updatedJson);
        setJsonData(updatedJson);  // Updates the state with the new JSON data
    };

    return (
        <div>
            <h1>JSON Editor</h1>
            {jsonData.length > 0 ? (
                <JsonEditor initialJson={jsonData} onChange={handleJsonChange} />
            ) : (
                <p>Loading JSON data...</p>  // Display a loading message or spinner while data is being fetched
            )}
        </div>
    );
}
